import {
  ApolloLink,
  FetchResult,
  SingleExecutionResult,
  fromPromise,
} from "@apollo/client";
import { hasCrypto } from "core/model/crypto";
import decryptPatcher from "./decryptPatcher";
import { getEncryptionDefinition } from "./queryKeys";
import { ContextType } from "./shared";

const decryptionPromise = (
  operationName: string,
  response: FetchResult<Record<string, any>>,
  context: ContextType,
): Promise<SingleExecutionResult<Record<string, any>>> =>
  new Promise((r) => {
    const { encryptionContext } = context;
    const data = response?.data;
    const definition = getEncryptionDefinition(operationName, "decrypt");

    if (
      data != null &&
      definition &&
      hasCrypto() &&
      encryptionContext?.decrypt === true
    ) {
      decryptPatcher({
        data,
        encryptionContext,
        encryptionDefinition: definition,
        mode: "decrypt",
      }).then((decryptedData) => {
        r({ data: decryptedData });
      });
    } else {
      r(
        response as
          | SingleExecutionResult<Record<string, any>>
          | PromiseLike<SingleExecutionResult<Record<string, any>>>,
      );
    }
  });

const decryptionLink = new ApolloLink((operation, forward) => {
  return forward(operation).flatMap((data) =>
    fromPromise(
      decryptionPromise(
        operation.operationName,
        data,
        operation.getContext() as ContextType,
      ),
    ),
  );
});

export default decryptionLink;
